"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubsectionVariants = void 0;
// NOTE: Please update the README.md in shared/questionnaire-engine if this is modified.
exports.SubsectionVariants = {
    form: 'form',
    summary: 'summary',
    quoter: 'quoter',
    addon: 'addon',
    blocking: 'blocking',
    submission: 'submission',
    payment: 'payment',
    productSelection: 'productSelection',
    productSummary: 'productSummary',
    priceUpdateWarning: 'priceUpdateWarning',
};
